module.exports = "pegasus_template/assets/themelp1/launch/201.png";